import { LegalShell, LegalSection, SUPPORT_EMAIL, SupportLink } from "../site/LegalShell.jsx";

// One inbox, deliberately. Splitting support across several addresses just
// slows replies down and loses booking context.
export default function ContactPage() {
  return (
    <LegalShell
      eyebrow="Contact"
      title="Talk to a human"
      intro="Questions about a stay, a booking you have already made, or something on the site that looks wrong — email us and a person will read it."
    >
      <div className="card p-8">
        <p className="text-xs uppercase tracking-[0.14em] text-ink-muted">Email us</p>
        <p className="mt-3 font-display text-2xl md:text-3xl leading-tight text-ink">
          <a href={`mailto:${SUPPORT_EMAIL}`} className="text-ocean-700 hover:text-ocean-900">{SUPPORT_EMAIL}</a>
        </p>
        <p className="prose-body mt-4">
          We aim to reply within one business day. Our team keeps Hawaiʻi hours (HST, UTC−10),
          so a note sent late in the day on the mainland is usually answered the next morning.
        </p>
        <a href={`mailto:${SUPPORT_EMAIL}`} className="btn-primary mt-6 inline-flex">Write to support</a>
      </div>

      <LegalSection heading="Already booked?">
        <p>
          Include your <strong>booking reference</strong>, the property name, and your check-in date.
          With those three things we can pull up the reservation on the first reply instead of the third.
        </p>
        <p>
          You can also view, change, or cancel a reservation yourself on the{" "}
          <a href="/booking/" className="text-ocean-700 underline underline-offset-2 hover:text-ocean-900">manage booking</a> page.
        </p>
      </LegalSection>

      <LegalSection heading="Travelling today or tomorrow?">
        <p>
          For anything time-critical once your trip has started — a late arrival, a room problem, a lost key —
          contact the property directly. Their phone number is on your confirmation email and on the property's
          page here. They can act immediately; we cannot. Email <SupportLink/> afterwards if something needs
          putting right on the booking itself.
        </p>
      </LegalSection>

      <LegalSection heading="Something wrong on the site?">
        <p>
          Wrong price, wrong photos, a property that has closed, a Hawaiian place name we have spelled without
          its ʻokina or kahakō — please tell us. Send the page link and what you saw. Corrections to property
          content are passed upstream to our supply partner, which is also how they reach the rest of the industry.
        </p>
      </LegalSection>

      <LegalSection heading="Working with us">
        <p>
          Property owners and managers who want their Hawaiʻi rental listed, and anyone with a partnership or
          press enquiry, can use the same address — put “Partnership” or “Press” at the front of the subject line
          and it will get routed.
        </p>
      </LegalSection>
    </LegalShell>
  );
}
